<form [formGroup]="paymentForm" (ngSubmit)="submit()">
  <div class="flex flex-col">
    <div class="mb-5">
      <label for="cardHolder">Titular de la Tarjeta</label>
      <input
        id="cardHolder"
        formControlName="cardHolder"
        type="text"
        class="input__base"
        placeholder="Nombre completo"
        [ngClass]="{
					error: shouldShowError('cardHolder', 'required'),
				}"
      />
      @if (shouldShowError('cardHolder', 'required')) {
      <div>
        <div class="error">Este campo es requerido.</div>
      </div>
      }
    </div>

    <div class="mb-5">
      <label for="cardNumber">Número de Tarjeta</label>
      <div class="credit__card__number">
        <input
          id="cardNumber"
          formControlName="cardNumber"
          type="text"
          placeholder="1234 5678 9012 3456"
          maxlength="19"
          class="input__base"
          (input)="onCardNumberInput($event)"
          [ngClass]="{
						error:
							shouldShowError('cardNumber', 'required') ||
							shouldShowError('cardNumber', 'invalidCard'),
					}"
        />
        @if (cardLogo) {
        <img [src]="cardLogo" alt="Logo de tarjeta" />
        }
      </div>
      @if (shouldShowError('cardNumber', 'required')) {
      <div>
        <div class="error">Este campo es requerido.</div>
      </div>
      } @if (shouldShowError('cardNumber', 'invalidCard')) {
      <div>
        <div class="error">El número de tarjeta no es válido.</div>
      </div>
      } @if (shouldShowError('cardNumber', 'invalidFormat')) {
      <div>
        <div class="error">Formato no válido. Solo se permiten números.</div>
      </div>
      }
    </div>

    <div class="flex gap-5">
      <div class="w-1/2">
        <label for="expirationDate">Vencimiento</label>
        <input
          id="expirationDate"
          formControlName="expirationDate"
          class="input__base"
          type="text"
          placeholder="MM/YY"
          maxlength="5"
          (input)="onExpirationDateInput($event)"
          [ngClass]="{
						error:
							shouldShowError('expirationDate', 'required') ||
							shouldShowError('expirationDate', 'pattern') ||
							shouldShowError('expirationDate', 'expiredDate'),
					}"
        />
        @if (shouldShowError('expirationDate', 'required')) {
        <div>
          <div class="error">Este campo es requerido.</div>
        </div>
        } @if (shouldShowError('expirationDate', 'pattern')) {
        <div>
          <div class="error">Formato inválido. Usa MM/YY.</div>
        </div>
        } @if (shouldShowError('expirationDate', 'expiredDate')) {
        <div>
          <div class="error">Tarjeta vencida.</div>
        </div>
        }
      </div>

      <div class="w-1/2">
        <label for="cvv">CVV</label>
        <input
          id="cvv"
          class="input__base"
          formControlName="cvv"
          type="password"
          maxlength="4"
          placeholder="123"
          autocomplete="cc-csc"
          [ngClass]="{
						error:
							shouldShowError('cvv', 'required') ||
							shouldShowError('cvv', 'maxlength'),
					}"
        />
        @if (shouldShowError('cvv', 'required')) {
        <div>
          <div class="error">Este campo es requerido.</div>
        </div>
        } @if (shouldShowError('cvv', 'maxlength')) {
        <div>
          <div class="error">El CVV debe tener 3 o 4 dígitos.</div>
        </div>
        }
      </div>
    </div>
  </div>
  <div class="mt-10">
    <activar-button
      text="Pagar"
      type="submit"
      fill="solid"
      color="primary"
      expand="full"
    />
  </div>
</form>
